import React from 'react';

/**
 * Brahmastra AI Logo - new design (slate base, white ब्र, glowing cyan spark)
 * Sizes: sm (32px), md (44px), lg (60px)
 */
const SIZE_MAP = {
  sm: { box: 'w-8 h-8 rounded-lg', letter: 'text-base', spark: 'text-[10px] -top-1 -right-1' },
  md: { box: 'w-11 h-11 rounded-xl', letter: 'text-2xl', spark: 'text-sm -top-1 -right-1' },
  lg: { box: 'w-14 h-14 rounded-2xl', letter: 'text-3xl', spark: 'text-base -top-1.5 -right-1.5' },
};

export const Logo = ({ size = 'md', testId = 'brahmastra-logo' }) => {
  const s = SIZE_MAP[size] || SIZE_MAP.md;
  return (
    <div
      className={`relative inline-flex items-center justify-center ${s.box} bg-slate-900 dark:bg-slate-900 shadow-lg border border-slate-700 shrink-0`}
      data-testid={testId}
      aria-label="Brahmastra AI Logo"
    >
      <span className={`text-white ${s.letter} font-bold devanagari leading-none`}>ब्र</span>
      <span
        className={`absolute ${s.spark} animate-pulse brahma-spark-glow select-none`}
        aria-hidden="true"
      >
        ✨
      </span>
    </div>
  );
};

export default Logo;
